export default __webpack_public_path__ + "static/media/icon-proceed.3e5100a2.svg";